import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'

//CHECK PROMOCODE IS VALID OR NOT
export const getOtpDetails = (postData) => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_OTP_REQUEST })
    return postRequest(APICONFIG.getOtpUrl, postData).then((res) => {
        dispatch({ type: CONSTANTS.GET_OTP_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_OTP_FAILURE })
        return err
    })
}

export const getConfirmOtp = (otpData) => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_CONFIRM_OTP_REQUEST })
    return postRequest(APICONFIG.getConfirmOtpUrl, otpData).then((res) => {
        dispatch({ type: CONSTANTS.GET_CONFIRM_OTP_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_CONFIRM_OTP_FAILURE })
        return err
    })
}